/**
 * Audit-Trail Status-Kennzahlen (Spec 530, Phase 1 — reine Logik).
 *
 * Client-seitige Ableitung der vier Status-Leisten-Kennzahlen aus den geladenen
 * Events. Rein (kein React/DOM/Netzwerk) → isoliert testbar. Das `truncated`-Flag
 * kommt aus `cursor != null` und wird durchgereicht, damit die UI die Zaehler
 * ehrlich als Untergrenze kennzeichnen kann (keine falsche Vollstaendigkeit).
 */

import type { AuditEvent } from '@/types/audit';

export interface AuditMetrics {
  /** Anzahl Events mit `result === 'denied'` (Anomaliesignal). */
  denied: number;
  /** Anzahl Events mit `tier === 1` (regulatorisch verpflichtend). */
  tier1: number;
  /** Anzahl der geladenen Events. */
  total: number;
  /** Juengster `timestamp` (ISO-8601 UTC) der geladenen Events, oder null bei leer. */
  lastActivityTs: string | null;
  /** True, wenn die Backend-Antwort abgeschnitten war (`cursor != null`). */
  truncated: boolean;
}

/**
 * Leitet die vier Status-Kennzahlen aus den geladenen Events ab (O(n)).
 *
 * `lastActivityTs` nutzt aus, dass ISO-8601-UTC-Zeitstempel lexikografisch
 * chronologisch sortierbar sind — das Maximum ist der juengste Zeitpunkt.
 */
export function deriveAuditMetrics(events: AuditEvent[], truncated = false): AuditMetrics {
  let denied = 0;
  let tier1 = 0;
  let lastActivityTs: string | null = null;

  for (const ev of events) {
    if (ev.result === 'denied') denied += 1;
    if (ev.tier === 1) tier1 += 1;
    if (lastActivityTs === null || ev.timestamp > lastActivityTs) {
      lastActivityTs = ev.timestamp;
    }
  }

  return { denied, tier1, total: events.length, lastActivityTs, truncated };
}
